<div class="host-stop-house-calendar-picker">
  <div class="calendar">
    <host-base-calendar [continuous]="true" [(ngModel)]="selectedDates"></host-base-calendar>
  </div>
  <div class="text-sm pt-[30px]">{{ selectedDatesInfo }}</div>

  <div class="footer pt-[30px] flex flex-row items-center justify-between">
    <div class="ml-auto">
      <button nz-button nzSize="large" class="mr-3" (click)="onCancel()">{{ "word.cancel" | translate }}</button>
      <button nz-button nzType="primary" nzSize="large" (click)="onConfirm()">{{ "word.confirm" | translate }}</button>
    </div>
  </div>
</div>
